import { cx } from '@mage-ui/styled-system/css';
import { arrowCta, focus, title } from '@mage-ui/styled-system/recipes';
import Link from 'next/link';
import { BigArrow } from './BigArrow';

export const ArrowCta = ({ data, ...props }) => {
  return (
    <Link
      href={data.cta_slug}
      className={cx(focus(), arrowCta().root, 'group')}
      {...props}
    >
      <span
        className={cx(title({ size: '2', weight: 'bold' }), arrowCta().text)}
      >
        {data.cta_text}
      </span>
      <BigArrow className={arrowCta().icon} />
    </Link>
  );
};
